// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__2K8SH","content":"Wrapper_content__2CbtT","isErrorContent":"Wrapper_isErrorContent__3o4ld","error":"Wrapper_error__1rIEw"};